import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { PlaneRoutePage } from "../app/planeRoute";

export const Route = createFileRoute("/effects")({
  component: EffectsRoute,
});

function EffectsRoute(): JSX.Element {
  const search = Route.useSearch();
  return <PlaneRoutePage kindId="effects" search={search} />;
}
